var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 145",
    style: {
      enableBackground: "new 0 0 145 145"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "women_8"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#8C7098"
    },
    width: 145,
    height: 145
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#10303F"
    },
    cx: 72.5,
    cy: 57.383,
    rx: 30.015,
    ry: 31.728
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M109.374,115.394c-4.963-9.396-36.874-15.292-36.874-15.292s-31.911,5.896-36.874,15.292 C31.957,128.433,28.888,145,28.888,145H72.5h43.612C116.112,145,114.039,127.236,109.374,115.394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M72.5,100.102c0,0,31.911,5.896,36.874,15.292c4.665,11.842,6.738,29.606,6.738,29.606H72.5 V100.102z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 81.001,
    style: {
      fill: "#F1C9A5"
    },
    width: 17.374,
    height: 29.077
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.5,
    y: 81.001,
    style: {
      fill: "#E4B692"
    },
    width: 8.687,
    height: 29.077
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#DDAC8C",
      enableBackground: "new"
    },
    d: "M63.813,94.474c1.562,4.485,7.869,7.057,12.5,7.057 c1.675,0,3.305-0.281,4.874-0.795V81.001H63.813V94.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M94.838,62.652c0-18.162-10.002-28.489-22.338-28.489S50.162,44.491,50.162,62.652 c0,18.162,10.001,32.887,22.338,32.887S94.838,80.814,94.838,62.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M91.438,75.245c-4.049-0.451-6.783-5.088-6.098-10.353c0.677-5.268,4.512-9.18,8.563-8.732 c4.047,0.449,6.777,5.084,6.093,10.353C99.318,71.781,95.487,75.689,91.438,75.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1C9A5"
    },
    d: "M45.161,66.513c-0.684-5.269,2.046-9.904,6.091-10.353c4.053-0.448,7.889,3.463,8.568,8.732 c0.684,5.265-2.053,9.901-6.1,10.353C49.671,75.689,45.84,71.781,45.161,66.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4B692"
    },
    d: "M94.838,62.652c0-18.162-10.002-28.489-22.338-28.489v61.375 C84.836,95.539,94.838,80.814,94.838,62.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E00315"
    },
    d: "M109.374,115.394c-0.296-0.561-0.694-1.109-1.17-1.646c-5.415,7.129-19.354,12.205-35.703,12.205 c-0.001,0-0.001,0-0.001,0l0,0c-0.001,0-0.001,0-0.001,0c-16.348,0-30.288-5.076-35.704-12.204 c-0.476,0.535-0.874,1.083-1.169,1.644C31.957,128.433,28.888,145,28.888,145H72.5h43.612 C116.112,145,114.039,127.236,109.374,115.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#452317"
    },
    d: "M73.599,83.247c-0.524,0-1.099,0.599-1.099,0.599s-0.574-0.599-1.099-0.599 c-0.524,0-1.648,0.936-2.659,1.048c1.348,1.348,2.909,1.834,3.757,1.834s2.409-0.486,3.757-1.834 C75.247,84.183,74.123,83.247,73.599,83.247z"
  })))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#10303F"
    },
    cx: 72.5,
    cy: 30.131,
    r: 15.108
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10303F"
    },
    d: "M96.669,60.095c0-0.054,0.004-0.106,0.004-0.16c0-14.089-9.538-28.956-22.889-28.956 c-13.35,0-25.456,14.867-25.456,28.956c0,0.054,0.003,0.106,0.003,0.16H96.669z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.813,
    y: 97.856,
    style: {
      fill: "#10303F"
    },
    width: 17.374,
    height: 4.18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.6c1e2f4f2e6e3cb0a46312bdc13958a0.svg";
export { ForwardRef as ReactComponent };